"use strict";

module.exports = function () {
  return window.location.protocol === "http:";
};